import axios from "axios";
import apiUrls from "../apiUrls";

const md_base_url = window.analytics_azure_workflow_url;

const TYPE_ON_SEARCH = 0
const TYPE_ON_REMEMBER_SEARCH = 1
const TYPE_ON_ADD_TO_FAVORITES = 2
const TYPE_ON_CATEGORY = 3
const TYPE_ON_VIEW_PRODUCT = 4
const TYPE_ON_LOGIN = 5

function isBot() {
  const botPatterns = [
    /bot/i,
    /spider/i,
    /crawl/i,
    /Googlebot/i,
    /Bingbot/i,
    /Slurp/i, // Yahoo
    /DuckDuckBot/i,
    /Baiduspider/i,
    /YandexBot/i,
    /Sogou/i,
    /Exabot/i,
    /facebookexternalhit/i,
    /facebot/i,
    /Twitterbot/i,
    /Applebot/i,
    /AhrefsBot/i,
    /SEMrushBot/i,
    /MJ12bot/i,
    /PetalBot/i
  ];

  return botPatterns.some(pattern => pattern.test(navigator.userAgent));
}

function sendEventToTheServer(body) {
  axios.post(apiUrls.sendLfEvent, body)
}

/**
 * equipmentType 0 - new, 1 - used
 * @param body
 */
function sendEvent(body) {
  try {
    if (isBot()) {
      // console.log("Blocked bot request:", navigator.userAgent);
      return; // Stop execution for bots
    }

    body.env = window.$envApp
    body.data.impressionURL = window.location.href

    try {
      sendEventToTheServer(body);
    } catch (e) {
      console.error("Failed to send event to lf", body, e)
    }


    axios.post(md_base_url, body)
    console.log("Send event", body)
  } catch (e) {
    console.error("Failed to send event", body, e)
  }

}

const actions = {

  async onSearch( store, { search, equipmentType, url }) {
    const email = store.rootGetters['user/getEmail']
    if (!email){
      // console.log("no sername")
      return
    }

    sendEvent({
      type: TYPE_ON_SEARCH,
      email: email,
      data: {
        equipmentType: equipmentType,
        searchString: search,
        url
      }
    })

  },

  async onSaveSearch ( store, { equipmentType }) {
    const email = store.rootGetters['user/getEmail']
    if (!email){
      return
    }

    sendEvent({
      type: TYPE_ON_REMEMBER_SEARCH,
      email: email,
      data: {
        equipmentType: equipmentType,
        url: window.location.href
      }
    })
  },

  async onAddFavorite( store, { equipmentType, model, stockNumber, sku, categoryTitle, url }) {
    const email = store.rootGetters['user/getEmail']
    if (!email){
      return
    }

    sendEvent({
      type: TYPE_ON_ADD_TO_FAVORITES,
      email: email,
      data: {
        equipmentType,
        model,
        stockNumber,
        sku,
        categoryTitle,
        url
      }
    })
  },

  async onProductView( store, { equipmentType, model, stockNumber, sku, categoryTitle }) {
    const email = store.rootGetters['user/getEmail']
    if (!email){
      return
    }

    sendEvent({
      type: TYPE_ON_VIEW_PRODUCT,
      email: email,
      data: {
        equipmentType,
        model,
        stockNumber,
        sku,
        categoryTitle,
        url: window.location.href
      }
    })
  },

  async onCategoryClicked( store, { equipmentType, categoryTitle, url}) {
    const email = store.rootGetters['user/getEmail']
    if (!email){
      return
    }

    // Use the current site's origin
    const domain = window.location.origin
    const fullUrl = url.startsWith('http://') || url.startsWith('https://')
      ? url
      : `${domain}${url.startsWith('/') ? '' : '/'}${url}`

    sendEvent({
      type: TYPE_ON_CATEGORY,
      email: email,
      data: {
        equipmentType,
        categoryTitle,
        fullUrl
      }
    })
  },

  async onLoginSuccess( store, data ) {
    const email = store.rootGetters['user/getEmail']
    if (!email){
      return
    }

    //Login way types
    if (data.loginWay === 1) {//save search
      data.url = window.location.href
    }

    const body = {
      type: TYPE_ON_LOGIN,
      email: email,
      data
    }

    sendEvent(body)
  }
}

const state = {}
const getters = {}
const mutations = {}
export default {
  namespaced: true,
  actions,
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/analytics.js